import {createContext, useContext} from 'react';
import noop from '@tinkoff/utils/function/noop';

export type VirtualizedContextType = {
    scrollToBottom: () => void;
    addScrollListener: (cb: () => unknown) => void;
    removeScrollListener: (cb: () => unknown) => void;
};

export const VirtualizedContext = createContext<VirtualizedContextType>({
    scrollToBottom: noop,
    addScrollListener: noop,
    removeScrollListener: noop,
});

export const useVirtualizedContext = () => useContext(VirtualizedContext);
